import React, { useEffect, useState } from 'react';

import { useMediaQuery, ThemeProvider, CssBaseline } from '@material-ui/core';

import theme from 'src/themes/homeTheme';

export default ({ children }) => {
  const [loading, setLoading] = useState(true);
  const matches = useMediaQuery('(min-width:600px)');
  useEffect(() => {
    setTimeout(() => {
      setLoading(false);
    }, 1000);
  }, []);

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      {children}
    </ThemeProvider>
  );
};
